import React from "react";
import { StepProgress } from "./stepProgress";

export const StepProgressContext = React.createContext<StepProgress | null>(
  null
);
